import { X } from 'lucide-react';
import { IconButton } from '@/shared/ui';

import { ArcadeEmbed } from '@/features/explainer-video/components/ArcadeEmbed';
import { Dialog } from '@/shared/ui/overlays/Modal';

interface ExplainerVideoModalProps {
  open: boolean;
  onClose: () => void;
}

const noop = () => {};

export const ExplainerVideoModal = ({ open, onClose }: ExplainerVideoModalProps) => (
  <Dialog
    className='sm:max-w-[800px] duration-0'
    open={open}
    onClose={noop}
  >
    <div className='flex items-center justify-end'>
      <IconButton
        aria-label='close'
        onClick={onClose}
      >
        <X size={20} />
      </IconButton>
    </div>
    <ArcadeEmbed />
  </Dialog>
);
